import { PillarState } from "@/components/PagePiller/redux/types";

const pillarInitialState: PillarState = {
  pillarData: undefined,
};

export default pillarInitialState;
